import React from "react";
import { useB2BTranslation } from "../../B2BShared/hooks/useB2BTranslation";
import B2BBackButton from "../../B2BShared/B2BBackButton";
import "./B2BDashboardBrandPerception.css";

const B2BDashboardBrandPerception: React.FC = () => {
  const { tDashboard } = useB2BTranslation();

  return (
    <div className="dashboard-brand-perception-container">
      {/* Header */}
      <div className="dashboard-brand-perception-header">
        <B2BBackButton
          to="/gcb/dashboard"
          translationKey="brandPerception.backToDashboard"
          variant="orange"
          size="medium"
          namespace="b2b"
        />
        <div className="brand-perception-header-content">
          <h1>{tDashboard("brandPerception.title")}</h1>
        </div>
      </div>

      {/* Empty Content */}
      <div className="empty-dashboard-content">
        <div className="empty-content-card">
          <h2>Dashboard Content Removed</h2>
          <p>
            This is the dashboard version of Brand Perception Management. All
            mock data has been removed.
          </p>
          <p>
            This page is accessible from within the GCB dashboard and is
            different from the public Brand Perception page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default B2BDashboardBrandPerception;

